import { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Layout from "../layouts/LayoutDefault.jsx";
import ContentContainer from "../components/ContentContainer";
import MainContainer from "../components/MainContainer";
import SmallTitleText from "../components/SmallTitleText";
import DropDownForm from "../components/DropDownForm";
import FormInputField from "../components/FormInputField";
import makePutRequest from "../components/utils/makePutRequest";
import makeDeleteRequest from "../components/utils/makeDeleteRequest";
import { clearToken } from "../store";

const EditProfilePage = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [changePWErrorMsg, setChangePWErrorMsg] = useState("");
  const [successPWMsg, setSuccessPWMsg] = useState("");
  const [changeMailErrorMsg, setChangeMailErrorMsg] = useState("");
  const [successMailMsg, setSuccessMailMsg] = useState("");
  const [mailChangeInProgress, setMailChangeInProgress] = useState(false);
  const [removeErrorMsg, setRemoveErrorMsg] = useState("");

  const changePasswordRef = useRef(null);
  const changeMailRef = useRef(null);
  const removeUserRef = useRef(null);

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setLoading(true);
    setChangePWErrorMsg("");
    setSuccessPWMsg("");

    if (changePasswordRef.current.checkValidity()) {
      const formElements = changePasswordRef.current.elements;

      let password = "";
      let rePassword = "";
      let oldPassword = "";
      // Check and validate
      for (let i = 0; i < formElements.length; i++) {
        const element = formElements[i];

        if (element.name === "oldPassword") {
          oldPassword = element.value;
        }
        if (element.name === "newPassword") {
          password = element.value.trim();
        }
        if (element.name === "rePassword") {
          rePassword = element.value.trim();
        }
      }
      if (password !== rePassword) {
        setChangePWErrorMsg("Lösenorden matchar inte");
        setLoading(false);
        return;
      }

      // Submit
      try {
        const data = {
          form: "passwordchange",
          data: {
            new_password: password,
            re_password: rePassword,
            old_password: oldPassword,
          },
        };
        const { error } = await makePutRequest(`edit_profile`, data);
        if (error) {
          throw new Error(error);
        }
      } catch (error) {
        setChangePWErrorMsg(error.message);
        setLoading(false);
      } finally {
        if (!changePWErrorMsg) {
          setSuccessPWMsg("Lösenordet uppdaterat");
        }
        setLoading(false);
      }
    }
  };
  const handleMailChange = async (e) => {
    e.preventDefault();
    setLoading(true);
    setChangeMailErrorMsg("");
    setSuccessMailMsg("");

    if (changeMailRef.current.checkValidity()) {
      const formElements = changeMailRef.current.elements;

      let mail = "";
      let remail = "";
      let password = "";

      // Check and validate
      for (let i = 0; i < formElements.length; i++) {
        const element = formElements[i];

        if (element.name === "mail") {
          mail = element.value;
        }
        if (element.name === "remail") {
          remail = element.value.trim();
        }
        if (element.name === "password") {
          password = element.value;
        }
      }
      if (mail !== remail) {
        setChangeMailErrorMsg("Epostadresserna matchar inte");
        setLoading(false);
        return;
      }

      // Submit
      try {
        const data = {
          form: "mailchange",
          data: {
            mail: mail,
            remail: remail,
            password: password,
          },
        };
        const { error } = await makePutRequest(`edit_profile`, data);
        if (error) {
          throw new Error(error);
        }
      } catch (error) {
        setChangeMailErrorMsg(error.message);
        setLoading(false);
      } finally {
        if (!changeMailErrorMsg) {
          setSuccessMailMsg(
            "Klicka på länken i din inkorg för att uppdatera eposten"
          );
          setMailChangeInProgress(true);
        }
        setLoading(false);
      }
    }
  };

  const handleRemoveUser = async (e) => {
    e.preventDefault();
    setLoading(true);
    setRemoveErrorMsg("");

    if (removeUserRef.current.checkValidity()) {
      const formElements = removeUserRef.current.elements;

      let password = "";

      // Check and validate
      for (let i = 0; i < formElements.length; i++) {
        const element = formElements[i];

        if (element.name === "password") {
          password = element.value;
        }
      }

      // Submit
      try {
        const data = {
          form: "delete_user",
          data: {
            password: password,
          },
        };
        const { error } = await makeDeleteRequest({
          route: "delete_profile",
          forceToken: true,
          redirectSuccessPath: "/register",
          data: data,
        });
        if (error) {
          throw new Error(error);
        }
      } catch (error) {
        setRemoveErrorMsg(error.message);
        setLoading(false);
      } finally {
        setLoading(false);
        // Logout user
        dispatch(clearToken());
      }
    }
  };
  return (
    <>
      <Layout
        title="Konto & profilinställningar"
        description="Ändra dina konto & profilinställningarinställningar"
      >
        <MainContainer>
          <ContentContainer>
            <div className="flex justify-between items-center ">
              <SmallTitleText text="Ändra profil" />
              <a href="/userprofile">
                <button className="btn btn-neutral border border-base-content/20">
                  Tillbaka
                </button>
              </a>
            </div>
            <p className="my-4">Ändra dina kontoinställningar</p>

            <div className="bg-neutral rounded-lg border border-base-content/20 p-2 mt-2">
              {/* Byt lösenord */}
              <DropDownForm
                title="Ändra lösenord"
                about="Byt till ett nytt lösenord"
              >
                <form
                  ref={changePasswordRef}
                  onSubmit={handlePasswordChange}
                  className="my-4 flex flex-col"
                >
                  <FormInputField
                    type="password"
                    name="oldPassword"
                    label="Nuvarande lösenord"
                    required={true}
                  />
                  <FormInputField
                    type="password"
                    name="newPassword"
                    label="Nytt lösenord"
                    required={true}
                  />
                  <FormInputField
                    type="password"
                    name="rePassword"
                    label="Upprepa lösenord"
                    required={true}
                  />
                  <button
                    disabled={loading}
                    className="btn btn-primary btn-wide border border-base-content/20"
                    type="submit"
                  >
                    Byt Lösenord
                  </button>
                </form>
                {changePWErrorMsg && (
                  <p className="font-semibold text-error">{changePWErrorMsg}</p>
                )}
                {successPWMsg && (
                  <p className="font-semibold text-success">{successPWMsg}</p>
                )}
              </DropDownForm>
              {/* Byt epost */}
              <DropDownForm
                title="Byt epostadress"
                about="Byt till annan epostadress"
              >
                <form
                  ref={changeMailRef}
                  onSubmit={handleMailChange}
                  className="my-4 flex flex-col"
                >
                  <FormInputField
                    type="email"
                    name="mail"
                    label="Nya epostadressen"
                    required={true}
                  />
                  <FormInputField
                    type="email"
                    name="remail"
                    label="Nya epostadressen igen"
                    required={true}
                  />
                  <FormInputField
                    type="password"
                    name="password"
                    label="Ditt lösenord"
                    required={true}
                  />
                  <button
                    disabled={loading || mailChangeInProgress}
                    className="btn btn-primary btn-wide border border-base-content/20"
                    type="submit"
                  >
                    Byt epost
                  </button>
                </form>
                {changeMailErrorMsg && (
                  <p className="font-semibold text-error">
                    {changeMailErrorMsg}
                  </p>
                )}
                {successMailMsg && (
                  <p className="font-semibold text-success">{successMailMsg}</p>
                )}
              </DropDownForm>
              {/* Ta bort konto */}
              <DropDownForm
                title="Ta bort konto"
                about="Radera konto, profil och allt innehåll du skapat på lokult"
              >
                <form
                  ref={removeUserRef}
                  onSubmit={handleRemoveUser}
                  className="my-4 flex flex-col"
                >
                  <FormInputField
                    type="checkbox"
                    name="verification"
                    label="Ta bort mitt konto"
                    bottomLabel="Inklusive alla profiler & inlägg"
                    required={true}
                  />
                  <FormInputField
                    type="password"
                    name="password"
                    label="Ditt lösenord"
                    bottomLabel="Behövs för att verifiera"
                    required={true}
                  />

                  <button
                    disabled={loading}
                    className="btn btn-error text-white btn-wide border border-base-content/20"
                    type="submit"
                  >
                    Radera
                  </button>
                </form>
                {removeErrorMsg && (
                  <p className="font-semibold text-error">{removeErrorMsg}</p>
                )}
                {successMailMsg && (
                  <p className="font-semibold text-success">{successMailMsg}</p>
                )}
              </DropDownForm>
            </div>
          </ContentContainer>
        </MainContainer>
      </Layout>
    </>
  );
};

export default EditProfilePage;
